import { render, staticRenderFns } from "./details-dropdown.component.vue?vue&type=template&id=08221a28&scoped=true"
import script from "./details-dropdown.component.vue?vue&type=script&lang=js"
export * from "./details-dropdown.component.vue?vue&type=script&lang=js"
import style0 from "./details-dropdown.component.vue?vue&type=style&index=0&id=08221a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08221a28",
  null
  
)

export default component.exports